export async function getLeads(clientId = null, salesRepId = null, status = null, startDate = null, endDate = null) {
    try {
        // Prepare the base API URL
        let apiUrl = 'https://xfot8e8uyj.execute-api.ap-southeast-1.amazonaws.com/prod/getLeads';

        // Initialize query parameters
        const queryParams = [];

        // Add client_id if provided
        if (clientId) {
            queryParams.push(`client_id=${encodeURIComponent(clientId)}`);
        }

        // Add sales_rep_id if provided
        if (salesRepId) {
            queryParams.push(`sales_rep_id=${encodeURIComponent(salesRepId)}`);
        }

        // Add status if provided
        if (status) {
            queryParams.push(`status=${encodeURIComponent(status)}`);
        }

        // Add start_date and end_date if both are provided
        if (startDate && endDate) {
            queryParams.push(`start_date=${encodeURIComponent(startDate)}`);
            queryParams.push(`end_date=${encodeURIComponent(endDate)}`);
        }

        // Construct full API URL with query parameters
        if (queryParams.length > 0) {
            apiUrl += `?${queryParams.join('&')}`;
        }

        // Make the API call
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data;  // Return the list of leads
        } else {
            console.error(`Error: Failed to fetch leads. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        console.error('Error: Network or other error occurred while fetching leads.', error);
        return null;
    }
}



export async function getLead(id) {
    try {
        const response = await fetch(`https://y4luoqv6q9.execute-api.ap-southeast-1.amazonaws.com/prod/getLead/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return await response.json(); // Return the parsed JSON response directly
    } catch (error) {
        console.error('Error fetching lead:', error);
        return null; // Return null if an error occurs
    }
}




export async function postLead(leadParameters = {}) {
    // Construct the payload with spread syntax
    const leadPayload = {
        lead_data: [
            {
                ...leadParameters, // Spread all properties from leadParameters
                user_create: leadParameters.user_create || 'system_default', // Default value
                user_update: leadParameters.user_update || 'system_default', // Default value
            },
        ],
    };

    console.log(leadPayload)
    try {
        // Make the API call
        const response = await fetch(
            'https://os646kchm7.execute-api.ap-southeast-1.amazonaws.com/prod/postLead',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(leadPayload),
            }
        );

        // Check for a successful response
        if (response.ok) {
            return await response.json(); // Return the response as JSON
        } else {
            console.error(`Error: Failed to post lead data. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while posting lead data.', error);
        return null;
    }
}


export async function putLead(leadId, leadParameters = {}) {
    // Prepare the payload to match Lambda's expected format
    const submitData = {
        lead_data: [  // Wrap the lead data inside lead_data array
            {
                ...leadParameters  // Spread all properties from leadParameters
            }
        ]
    };

    try {
        console.log('Submitting updated lead data:', submitData);

        const response = await fetch(
            `https://xnlmcifel0.execute-api.ap-southeast-1.amazonaws.com/prod/putLead/${leadId}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(submitData),  // Convert to JSON string
            }
        );

        const result = await response.json();

        if (response.ok) {
            console.log('Lead updated successfully!', result);
            return { success: true, data: result };
        } else {
            console.error('Error updating lead:', result);
            return { success: false, error: result };
        }
    } catch (error) {
        console.error('Network or other error occurred while updating lead:', error);
        return { success: false, error };
    }
}



